<template>
  <div class="card mb-1 pt-2">
    <div class="card-body p-4 p-md-5">
      <h5 class="text-highlighted mb-3">{{ $t("account_information") }}</h5>
      <form class="personal-info-form" @submit.prevent="sendRegistrationForm()">
        <form-group v-model="formModel" :fields="formSchema" />
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-outline-highlighted col-12 col-md-3"
          >
            <font-awesome-icon
              v-if="loading"
              icon="spinner"
              class="ml-2"
              spin
            />
            {{ $t("continue") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import FormGroup from "./form/FormGroup";
import { token } from "@/store/modules/onboarding";

export default {
  name: "RegistrationForm",
  components: {
    FormGroup
  },
  data() {
    return {
      loading: false,
      formModel: {
        username: "",
        email: "",
        phone: "",
        password: "",
        passwordRetry: "",
        SFA: "",
        clientZone: false
      },
      formSchema: [
        {
          label: this.$t("birth_number_or_cid"),
          placeholder: this.$t("birth_number_or_cid_placeholder"),
          model: "username",
          formWrapperClass: "col-md-6",
          required: true
        },
        {
          label: this.$t("email"),
          placeholder: this.$t("email_placeholder"),
          model: "email",
          formWrapperClass: "col-md-6",
          type: "email",
          required: true
        },
        {
          label: this.$t("password"),
          placeholder: this.$t("password_placeholder"),
          model: "password",
          formWrapperClass: "col-md-6",
          type: "password",
          required: true
        },
        {
          label: this.$t("passwordConfirmation"),
          placeholder: this.$t("passwordConfirmation_placeholder"),
          model: "passwordRetry",
          formWrapperClass: "col-md-6",
          type: "password",
          required: true
        },
        {
          label: this.$t("phone"),
          placeholder: this.$t("phone_placeholder"),
          model: "phone",
          formWrapperClass: "col-md-6",
          mask: "+### ### ### ###",
          required: true
        },
        {
          label: this.$t("sfa_code"),
          placeholder: this.$t("sfa_code_placeholder"),
          model: "SFA",
          formWrapperClass: "col-md-6",
          required: false
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("onboarding/testServiceDown");
  },
  methods: {
    sendRegistrationForm() {
      if (this.formModel.password.length < 6) {
        this.$store.dispatch(
          "alert/warning",
          "password_must_contain_minimum_of_six_symbols"
        );
      } else if (this.formModel.password !== this.formModel.passwordRetry) {
        this.$store.dispatch(
          "alert/warning",
          "passwords_are_not_the_same"
        );
      } else {
        this.loading = true;
        this.$store
          .dispatch("onboarding/registration", this.formModel)
          .then(() => {
            this.$store
              .dispatch("onboarding/login", this.formModel)
              .then(() => {
                this.loading = false;
                this.$store.commit("onboarding/setRegistration", true);
                this.$parent.$parent.currentStep.next = true;
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss">
.personal-info-form {
  h3 {
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 10px;
  }

  hr {
    border-top-color: #9b9c9c;
    margin-top: 20px;
  }

  p {
    font-size: 12px;
    line-height: 170%;
  }
}
</style>
